<template>
  <div>
    <v-row>
      <v-col md="12">
        <v-stepper v-model="step" @reload="reloadstep($event)" non-linear>
          <v-stepper-header>
            <v-stepper-step
              :complete="step > 1"
              step="1"
              :color="`${buttonColor}`"
              >{{ $t("authorization.add.title_step_1") }}</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step
              :complete="step > 1.1"
              step="1.1"
              :color="`${buttonColor}`"
              >{{ $t("authorization.add.title_step_2") }}</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step
              :complete="step > 1.2"
              step="1.2"
              :color="`${buttonColor}`"
              >{{ $t("authorization.add.title_step_3") }}</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step
              :complete="step > 2"
              step="2"
              :color="`${buttonColor}`"
              >{{ $t("authorization.add.title_step_4") }}</v-stepper-step
            >
          </v-stepper-header>
          <v-stepper-items class="st_items">
            <v-stepper-content step="1">
              <v-container>
                <v-row>
                  <v-col md="12" cols="12" class="text-center">
                    <p class="mb-0">
                      {{ $t("authorization.add.content_step_1") }}
                    </p>
                    <p class="mb-0 war">
                      {{ $t("authorization.add.content_step_1_war") }}
                    </p>
                  </v-col>
                  <v-col md="12" cols="12" class="text-center">
                    <h2>{{ $t("authorization.add.subtitle_step_1") }}</h2>
                  </v-col>
                  <v-col class="d-flex flex-column flex-sm-row justify-center align-center">
                    <v-btn
                      @click="yesCreated"
                      :color="buttonColor"
                      class="btn_bg w-100 w-sm-auto mb-4 mb-sm-0 mr-sm-2"
                    >
                      {{ $t("authorization.add.button_yes_create_account") }}
                    </v-btn>

                    <v-btn
                      @click="dialog = true"
                      :color="buttonColor"
                      class="btn_bg w-100 w-sm-auto ml-sm-2"
                    >
                      {{ $t("authorization.add.button_no_create_account") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
              <v-row>
                <v-col md="12" cols="12">
                    <v-btn dark :color="`${buttonColor}`" class="ma-4" @click="goBack">{{ $t("common.back")}}</v-btn>
                </v-col>
              </v-row>
            </v-stepper-content>
            <v-stepper-content step="1.1">
              <v-row class="mb-2">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="10" class="mx-auto text-center">
                          <p class="mb-0">
                            {{ $t("authorization.add.content_step_2") }}
                          </p>
                          <p class="mb-0 war">
                            {{ $t("authorization.add.content_step_2_war") }}
                          </p>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-form
                ref="formEmail"
                class="mt-sm-0 mt-4"
                @submit.prevent="searchByEmail"
              >
                <v-row>
                  <v-col md="3" sm="4" cols="12" class="pt-0 pb-0 lbl_search">
                    <label class="lbl_search">
                      <v-icon>fa fa-search</v-icon>
                      {{ $t("riders.createRiders.find_by_email") }}
                    </label>
                    <v-text-field
                      v-model="email"
                      :rules="rules.email"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col md="3" sm="4" cols="12">
                    <v-btn
                      class="mt-sm-4 mt-0 btn_xs_rsp"
                      type="submit"
                      :loading="loadingEmail"
                    >
                      {{ $t("riders.createRiders.search_by_email") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
              <v-form
                ref="formLLId"
                class="mt-sm-0 mt-4"
                @submit.prevent="searchByLLId"
              >
                <v-row>
                  <v-col md="3" sm="4" cols="12" class="pt-0 pb-0 lbl_search">
                    <label class="lbl_search">
                      <v-icon>fa fa-search</v-icon>
                      {{ $t("riders.createRiders.find_by_ll_id") }}
                    </label>
                    <v-text-field
                      v-model="LLId"
                      :rules="rules.LLId"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col md="3" sm="4" cols="12">
                    <v-btn
                      class="mt-sm-4 mt-0 btn_xs_rsp"
                      type="submit"
                      :loading="loadingId"
                    >
                      {{ $t("riders.createRiders.search_by_ll_id") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
              <v-row no-gutters class="mt-sm-0 mt-6">
                <v-col md="12" cols="12">
                  <h4>{{ $t("authorization.add.search_results_table") }}</h4>
                </v-col>
                <v-col md="12" cols="12" class="mb-1">
                  <!-- Table ... -->
                  <v-data-table
                    :headers="headers"
                    :items="items"
                    @click:row="selectRow"
                    item-key="id"
                    class="elevation-2 ma-0 dt_rider"
                    dense
                    :footer-props="{
                      'items-per-page-text': $t('dataTable.rowsPerPageText'),
                      'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                    }"
                    :no-data-text="$t('dataTable.noDataText')"
                    :headerProps="{
                      'sort-by-text': $t('dataTable.sortByText')
                    }"
                  >
                    <template v-slot:[`item.selected`]="{ item }">
                      <v-simple-checkbox v-model="item.selected" :ripple="false" @click="selectRow(item)"></v-simple-checkbox>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col v-if="participantSelected" class="text-left my-6 mt-md-1" md="12" cols="12">
                  <!-- card selected -->
                  <h4>{{ $t("riders.createRiders.selected_rider") }}</h4>
                  <v-card max-width="344" outlined>
                    <v-list-item
                      v-for="(item, index) in selected"
                      :key="index"
                      two-line
                    >
                      <v-list-item-avatar
                        tile
                        size="80"
                        color="grey"
                        class="mb-2 mt-2"
                      >
                        <v-img
                          height="100%"
                          width="100%"
                          :src="item.image"
                          v-on:error="ImgError"
                        ></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title
                          >{{ item.firstName }}
                          {{ item.lastName }}</v-list-item-title
                        >
                        <v-list-item-title
                          >{{ $t("riders.createRiders.table_header_ll_id") }}:
                          {{ item.id }}
                          <div
                            style="position: absolute; right: 5px; top: 5px;"
                          >
                            <v-btn depressed color="error" @click="selectRow(item)">
                              <v-icon>
                                mdi-close
                              </v-icon>
                            </v-btn>
                          </div>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-col>
              </v-row>

              <v-row class="mb-2">
                <v-col cols="6" class="text-left">
                    <v-btn
                      @click="noCreated"
                      :color="`${buttonColor}`"
                      class="btn_back"
                    >{{ $t("riders.createRiders.back_button") }}</v-btn>
                </v-col>
                <v-col cols="6" v-if="selected.length > 0" class="text-right">
                  <v-btn
                    @click="yesCreated"
                    :color="`${buttonColor}`"
                    class="btn_back"
                    >{{ $t("riders.createRiders.next") }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-stepper-content>
            <v-stepper-content step="1.2">
              <v-container>
                <v-row>
                  <v-col md="8" offset-md="2">
                    <v-row>
                      <v-col md="6" class="text-center">
                        <v-btn
                          :href="`${LIVELAPS_HOST}/registration/participant`"
                          :color="`${buttonColor}`"
                          class="mt-6 mb-6 btn_bg"
                          target="_blank"
                          >{{
                            $t("riders.createRiders.create_account_btn")
                          }}</v-btn
                        >
                      </v-col>
                      <v-col md="6" class="text-center">
                        <v-btn
                          @click="noCreated"
                          :color="`${buttonColor}`"
                          class="mt-6 mb-6 btn_bg"
                          >{{
                            $t("riders.createRiders.create_already_btn")
                          }}</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-container>
                <v-form ref="formAddRider" @submit.prevent="addRider">
                  <v-row>
                    <v-col md="12">
                      <p class="mb-0">
                        {{ $t("authorization.add.content_step_3") }}
                      </p>
                    </v-col>
                  </v-row>
                  <div v-for="(item, index) in selected" :key="index">
                    <v-row>
                      <v-col md="6" class="text-left">
                        <v-card max-width="344" outlined>
                          <v-list-item two-line>
                            <v-list-item-avatar
                              tile
                              size="80"
                              color="grey"
                              class="mb-2 mt-2"
                            >
                              <v-img
                                height="100%"
                                width="100%"
                                :src="item.image"
                                v-on:error="ImgError"
                              ></v-img>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title
                                >{{ item.firstName }}
                                {{ item.lastName }}</v-list-item-title
                              >
                              <v-list-item-title
                                >{{
                                  $t("riders.createRiders.table_header_ll_id")
                                }}: {{ item.id }}</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="6">
                        <p>
                          {{
                            $t("riders.whois") +
                              item.firstName +
                              " " +
                              item.lastName +
                              " (" +
                              item.id +
                              ") " +
                              $t("riders.whoisto") +
                              " " +
                              user.firstName +
                              " " +
                              user.lastName
                          }}?
                        </p>
                        <v-select
                          dense
                          outlined
                          v-model="select1[item.id]"
                          :rules="rules.select"
                          :label="$t('riders.relationship')"
                          :items="itemsRelationshipOptions"
                          item-text="text"
                          item-value="id"
                          :no-data-text="$t('common.no_data')"
                        >
                        </v-select>
                      </v-col>
                    </v-row>
                  </div>
                  <v-row>
                    <v-col md="6" class="text-left">
                      <v-btn
                        @click="noCreated"
                        :color="`${buttonColor}`"
                        class="btn_back btn_bg"
                        >{{ $t("riders.createRiders.back_button") }}</v-btn
                      >
                    </v-col>
                    <v-col md="6" v-if="selected.length > 0" class="text-right">
                      <v-btn
                        type="submit"
                        :color="`${buttonColor}`"
                        class="btn_back btn_bg ml-auto"
                        >{{ $t("authorization.add.create") }}</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{
            $t("authorization.add.title_create_account_parent")
          }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <p class="text-body-1 text-dark-custom">
              {{ $t("authorization.add.text_create_account_parent_1") }}
            </p>
            <p class="war">
              {{ $t("authorization.add.text_create_account_parent_2") }}
            </p>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :color="`${buttonColor}`"
            @click="noCreatedAccount"
            class="text-white"
          >
            {{ $t("authorization.add.create_adult_account") }}
          </v-btn>
          <v-btn :color="`${buttonColor}`" text @click="dialog = false">
            {{ $t("common.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snack
      :snack="snackbar"
      :snackMsg="msg_snackbar"
      :snackCol="color_snackbar"
    />
  </div>
</template>

<script>
import RelationshipService from "../../services/RelationshipService";
import AuthService from "../../services/AuthService";
import LoginService from "@/services/LoginService";
import {
  VRow,
  VCol,
  VStepperItems,
  VForm,
  VSelect,
  VStepper,
  VStepperContent,
  VContainer,
  VBtn,
  VDataTable,
  VTextField,
  VIcon,
  VStepperStep,
  VDivider,
  VStepperHeader,
  VListItemTitle,
  VListItemContent,
  VListItem,
  VImg,
  VListItemAvatar,
  VCard,
  VDialog,
  VCardTitle,
  VCardText,
  VCardActions,
  VSpacer,
  VSimpleCheckbox
} from "vuetify/lib";
import Snack from "@/components/notifications/Snack";
import LocalStorageService from "@/services/LocalStorageService";
import { mapState } from "vuex";

export default {
  name: "CreateAuthorization",
  components: {
    VRow,
    VCol,
    VStepperItems,
    VForm,
    VSelect,
    VStepper,
    VStepperContent,
    VContainer,
    VBtn,
    VDataTable,
    VTextField,
    VIcon,
    VStepperStep,
    VDivider,
    VStepperHeader,
    VListItemTitle,
    VListItemContent,
    VListItem,
    VImg,
    VListItemAvatar,
    VCard,
    Snack,
    VDialog,
    VCardTitle,
    VCardText,
    VCardActions,
    VSpacer,
    VSimpleCheckbox
  },
  data() {
    const createForm = Object.freeze({
      firstName: "",
      lastName: "",
      relationship: "",
      type: "",
    });
    return {
      step: 1,
      createForm,
      form: Object.assign({}, createForm),
      dynamicMenuItems: [],
      selected: [],
      items: [],
      singleSelect: false,
      select1: [],
      itemsRelationship: [],
      buttonColor: "#000",
      email: null,
      LLId: null,
      participantSelected: false,
      imageUrl: null,
      failed_image: true,
      user: null,
      LIVELAPS_HOST: null,
      userRoleId: 0,
      userRolePartId: 0,
      userRolesItems: [],
      snackbar: false,
      msg_snackbar: "",
      color_snackbar: "",
      loadingEmail: false,
      loadingId: false,
      dialog: false,
    };
  },
  created() {
    this.buttonColor = this.$store.getters.env.get("VUE_APP_BUTTON_COLOR");
    this.LIVELAPS_HOST = this.$store.getters.env.get("VUE_APP_LIVELAPS_HOST");
    this.itemsRelationship_();
  },
  mounted() {
    this.$emit("titlePage", "riders.addRiders");
    this.$emit("dynamicMenuItems", this.dynamicMenuItems);
  },
  updated() {
    this.itemsSelected();
  },
  computed: {
    createFormIsValid() {
      return (
        this.form.firstName &&
        this.form.lastName &&
        this.form.relationship &&
        this.form.type
      );
    },
    headers() {
      return [
        {
          text: this.$t("common.table.select"),
          value: "selected",
          sortable: false
        },
        {
          text: this.$t("riders.createRiders.table_header_ll_id"),
          value: "id",
        },
        {
          text: this.$t("riders.createRiders.table_header_first_name"),
          value: "firstName",
        },
        {
          text: this.$t("riders.createRiders.table_header_last_name"),
          value: "lastName",
        },
      ];
    },
    ...mapState({
      userStore: (state) => state.session.user,
    }), 
    itemsRelationshipOptions(){
      return this.itemsRelationship.map((el) => {
        return {
          text: this.$t(`relationship.${el.toLowerCase()}`),
          id: el
        }
      }).sort((a, b) => a.text.localeCompare(b.text));
    },
    rules() {
      return {
        email: [
          val => this.$inputRules({ value: val }, 'email') || this.$t("common.email_invalid")
        ],
        LLId:[
          val => this.$inputRules({ value: val }, 'integer') || this.$t("riders.id_number_invalid")
        ], 
        select:[
          val => this.$inputRules({ value: val }, 'filled') || this.$t("riders.select_required")
        ],
      };
    }
  },
  methods: {
    async itemsRelationship_() {
      await RelationshipService.showRelationshipValues().then((response) => {
        if (response.data.success == 1) {
          // AMA Waiver Bypass v2: self-service authorization screens must
          // never offer `Other`; it is a waiver-flow-only value that also
          // blocks the adult/minor pair from progressing.
          const values = Array.isArray(response.data.message) ? response.data.message : [];
          this.itemsRelationship = values.filter(v => String(v).toLowerCase() !== 'other');
        }
      });

      await RelationshipService.getUserRoles().then((response) => {
        if (response.data.success == 1) {
          this.userRolesItems = response.data.message;
          this.userRolesItems.find((x) => {
            if (x.userRoleCode === "AuthorizedUser") {
              this.userRoleId = x.id;
            }
            if (x.userRoleCode == "Participant") {
              this.userRolePartId = x.id;
            }
          });
        }
      });

      AuthService.getUserCurrent().then((response) => {
        if (response.data.success == 1) {
          this.user = response.data.message;
        }
      });
    },
    async ImgError() {
      this.failed_image = false;
    },
    selectRow(item) {
      let _item = this.selected.indexOf(item);
      let _item1 = this.items.indexOf(item);
      if (_item > -1) {
        this.selected.splice(_item, 1);
        if(_item1 > -1) this.items[_item1].selected = false;
      } else {
        this.selected.push(item);
        if(_item1 > -1) this.items[_item1].selected = true;
      }
      if(_item1 <= -1) this.items[_item1].selected = false;
    },
    itemsSelected() {
      if (this.selected.length > 0) {
        this.participantSelected = true;
      } else {
        this.participantSelected = false;
      }
    },
    searchByEmail() {
      if (!this.$refs.formEmail.validate()) {
        return;
      }

      if (this.email == this.userStore.email) {
        this.items = [];
        this.showSnackBar(this.$t("common.cannot_add_yourself"), "error");
        return;
      }
      this.loadingEmail = true;
      RelationshipService.relationshipFinder("emailAddress", this.email)
        .then((response) => {
          this.loadingEmail = false;
          if (response.data.success == 1) {
            for (var i = 0; i < response.data.message.length; i++) {
              response.data.message[i].image =
                response.data.message[i].image != null &&
                response.data.message[i].image.length > 0
                  ? this.$store.getters.env.get("VUE_APP_ROOT") +
                    "/" +
                    response.data.message[i].image
                  : require("@/assets/images/orgPlaceholder.jpg.png");
            }

            this.items = response.data.message.filter((el) => {
              return el.id != this.userStore.id;
            }).map((el) => { return {...el, selected: false }; });
          } else {
            this.items = [];
          }
        })
        .catch(() => {
          this.loadingEmail = false;
        });
    },
    searchByLLId() {
      if (!this.$refs.formLLId.validate()) {
        return;
      }

      if (this.LLId == this.userStore.id) {
        this.items = [];
        this.showSnackBar(this.$t("common.cannot_add_yourself"), "error");
        return;
      }
      this.loadingId = true;
      RelationshipService.relationshipFinder("id", this.LLId)
        .then((response) => {
          this.loadingId = false;
          if (response.data.success == 1) {
            for (var i = 0; i < response.data.message.length; i++) {
              response.data.message[i].image =
                response.data.message[i].image != null &&
                response.data.message[i].image.length > 0
                  ? this.$store.getters.env.get("VUE_APP_ROOT") +
                    "/" +
                    response.data.message[i].image
                  : require("@/assets/images/orgPlaceholder.jpg.png");
            }
            this.items = response.data.message.filter((el) => {
              return el.id != this.userStore.id;
            }).map((el) => { return {...el, selected: false }; });
          } else {
            this.items = [];
          }
        })
        .catch(() => {
          this.loadingId = false;
        });
    },
    yesCreated() {
      switch (this.step) {
        case 1:
          this.step = 1.1;
          break;
        case 1.1:
          this.step = 2;
          break;
      }
    },
    noCreated() {
      switch (this.step) {
        case 1.1:
          this.step = 1;
          this.cleanData();
          break;
        case 2:
          this.step = 1.1;
          break;
        case 1:
          this.step = 1.2;
          break;
        case 1.2:
          this.step = 1;
          break;
      }
    },
    noCreatedAccount() {
      LoginService.logout().then((response) => {
        if (response.data.success == 1) {
          this.dialog = false;
          if (this.$store.getters.env.get("VUE_APP_PARENT_ACCOUNT_CREATE")) {
            window.location.href = this.$store.getters.env.get(
              "VUE_APP_PARENT_ACCOUNT_CREATE"
            );
          } else {
            this.showSnackBar(this.$t("common.error_general"), "error");
          }
        }
      });
    },
    cleanData() {
      this.selected = [];
      this.email = null;
      this.LLId = null;
      this.participantSelected = false;
      this.items = [];
    },
    cancel() {
      this.step = 1;
      this.cleanData();
    },
    async addRider() {
      if (!this.$refs.formAddRider.validate()) {
        return;
      }

      for (var i = 0; i < this.selected.length; i++) {
        await RelationshipService.relationshipCreator({
          relId: this.selected[i].id,
          relType: this.select1[this.selected[i].id],
          userRolesId: this.userRoleId,
        }).then((response) => {
          if (response.data.success == 1) {
            RelationshipService.relationshipCreator({
              userId: this.selected[i].id,
              relId: this.user.id,
              relType: "",
              userRolesId: 2,
            });
          }
        });
      }
      this.$router.push({
        path: "Authorization",
      });
    },
    createAccount() {
      this.$router.push({
        path: "registration",
      });
    },
    showSnackBar(msg, color) {
      this.snackbar = true;
      this.msg_snackbar = msg;
      this.color_snackbar = color;
      setTimeout(() => (this.snackbar = false), 3000);
    },
    goBack() {
      const previusLink = LocalStorageService.getItem("previus_link");
      this.$router.push({ name: previusLink.name, query: previusLink.query, params: previusLink.params });
    }
  },
  watch: {
    selected(val) {
      const minorPart = val.find((el) => {
        return el.age < 18;
      });
      if (minorPart) {
        const validPart = val.filter((el) => {
          return el.age >= 18;
        });
        this.selected = validPart;
        this.showSnackBar(this.$t("authorization.minor_manager"), "error");
      }
    },
  },
};
</script>

<style>
.btn_bg {
  height: 50px !important;
  min-width: 250px !important;
  color: #fff !important;
  max-width: 100%;
  white-space: normal;
  display: block;
  /*margin: auto;*/
}
.btn_back {
  height: 50px !important;
  color: #fff !important;
}
.lbl_search .v-icon {
  margin-bottom: 5px;
  font-size: 18px;
}
.dt_rider .v-data-footer {
  height: 38px;
}
.dt_rider .v-data-footer__select .v-select {
  margin: 0px 0px 0px 34px;
}
.dt_rider .v-data-table-header {
  background: #ccc;
}
.st_items .v-stepper__content {
  padding-top: 12px;
}
.war {
  color: red;
  font-size: 18px;
}
.text-white {
  color: #fff !important;
}
.text-dark-custom {
  color: rgba(0, 0, 0, 0.87);
}
/*@media (max-width: 959px) {
  .btn_bg {
    max-width: 100%;
    min-width: auto !important;
    height: auto !important;
  }
}*/
@media (max-width: 599px) {
  .btn_bg,
  .btn_xs_rsp {
    max-width: 100%;
    min-width: auto !important;
    height: auto !important;
  }
  .btn_bg span,
  .btn_xs_rsp span {
    white-space: normal;
    max-width: 100%;
  }
  .btn_bg {
    min-height: 50px;
  }
  .btn_xs_rsp {
    min-height: 36px;
  }
  .v-snack__wrapper {
    min-width: 0px;
  }
}
</style>
